import React from 'react';

const Tabs = ({ activeCount, inactiveCount, selectedTab, onTabChange }) => {
  return (
    <div className="tabs">
      <div
        className={`tab ${selectedTab === 'active' ? 'active' : ''}`}
        onClick={() => onTabChange('active')}
      >
        <span>Active Plans ({activeCount})</span>
      </div>
      <span className='pipe'></span>
      <div
        className={`tab ${selectedTab === 'inactive' ? 'active' : ''}`}
        onClick={() => onTabChange('inactive')}
      >
        <span>Inactive Plans ({inactiveCount})</span>
      </div>
    </div>
  );
};

export default Tabs;